export const getRankColor = (rank: number) => {
  const rankNumber = rank > 0 ? rank - 1 : 9

  return RANK_COLORS[rankNumber >= 9 ? 9 : rankNumber]
}

export const RANK_COLORS = [
  '#3E74EF', // 1
  '#FF3649', // 2
  '#F7C96D', // 3
  '#EBE9E6', // 4
  '#FFBED9', // 5
  '#5ECF84', // 6
  '#9D7DDE', // 7
  '#D2905F', // 8
  '#DFDFDF', // 9
  '#A1C1FC', // 10
]
